import ReactGA from "react-ga4";

export const DEFAULT_GA_MEASUREMENT_ID = "G-VH88X78D14";

const PII_PARAM_KEYS = new Set([
  "name",
  "email",
  "phone",
  "message",
  "full_name",
  "email_address",
  "phone_number",
]);

export type AnalyticsParams = Record<
  string,
  string | number | boolean | undefined | null
>;

let initialized = false;

const resolveMeasurementId = (): string =>
  process.env.REACT_APP_GA_MEASUREMENT_ID?.trim() || DEFAULT_GA_MEASUREMENT_ID;

const sanitizeParams = (
  params?: AnalyticsParams
): Record<string, string | number | boolean> => {
  if (!params) return {};
  const clean: Record<string, string | number | boolean> = {};
  for (const [key, value] of Object.entries(params)) {
    if (value == null) continue;
    if (PII_PARAM_KEYS.has(key.toLowerCase())) continue;
    clean[key] = value;
  }
  return clean;
};

export const initAnalytics = (
  measurementId: string = resolveMeasurementId()
): void => {
  if (initialized || !measurementId) return;
  try {
    ReactGA.initialize(measurementId);
    initialized = true;
  } catch (error) {
    console.error("Failed to initialize Google Analytics:", error);
  }
};

export const trackPageView = (path: string): void => {
  if (!initialized) return;
  try {
    ReactGA.send({ hitType: "pageview", page: path });
  } catch (error) {
    console.error("Failed to track page view:", error);
  }
};

export const trackEvent = (
  eventName: string,
  params?: AnalyticsParams
): void => {
  if (!initialized || !eventName) return;
  try {
    ReactGA.event(eventName, sanitizeParams(params));
  } catch (error) {
    console.error("Failed to track event:", error);
  }
};

/** Test helper — resets module init state. */
export const __resetAnalyticsForTests = (): void => {
  initialized = false;
};
